/*
 * Project: forca
 * File Created: Thursday, 16th September 2021 1:28:40 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React from 'react';

import Accordion from '@Components/accordion';

import { AccordionsProps } from './accordions.definition';

export const Accordions = (props: AccordionsProps) => {
	const {
		boxes = [],
		overskrift,
		elementMargin
	} = props;

	return (
		<div
			className={ [
				'Accordions',
				elementMargin ? `mb-${elementMargin}` : ''
			].join(' ') }
		>
			{ overskrift && (
				<h4 className="Accordions-Headline">{ overskrift }</h4>
			) }
			{ boxes.map((item) => {
				const {
					expanded,
					headline,
					subHeadline,
					content,
					cta
				} = item;

				return (
					<Accordion
						key={ headline }
						headline={ headline }
						subHeadline={ subHeadline }
						content={ content }
						expanded={ expanded }
						cta={ cta }
					/>
				);
			}) }
		</div>
	);
};

export default Accordions;